<div class="activity">
  @if (isLoading()) {
    <p class="activity__hint">
      {{ 'app.patrol.discord.cockpit.activity.loading' | translate }}
    </p>
  } @else if (loadError()) {
    <p class="activity__error" role="alert">
      {{ 'app.patrol.discord.cockpit.activity.loadError' | translate }}
    </p>
  } @else if (activityStats().length > 0) {
    <div class="stat-grid">
      @for (stat of activityStats(); track stat.id) {
        <article class="stat-card">
          <p class="stat-card__label">{{ stat.labelKey | translate }}</p>
          <p class="stat-card__value">{{ stat.value }}</p>
          @if (stat.trendKey) {
            <p
              class="stat-card__trend"
              [class.stat-card__trend--up]="stat.trendDirection === 'up'"
              [class.stat-card__trend--down]="stat.trendDirection === 'down'"
            >
              {{ stat.trendKey | translate: stat.trendParams }}
            </p>
          }
        </article>
      }
    </div>
  }

  @if (!isLoading() && !loadError()) {
  <section class="cases-card">
    <h2 class="section-title">
      {{ 'app.patrol.discord.cockpit.activity.recentCases' | translate }}
    </h2>
    <p class="section-hint">
      {{ 'app.patrol.discord.cockpit.activity.recentCasesHint' | translate }}
    </p>

    @if (recentCases().length > 0) {
      <div class="table-wrap">
        <table class="cases-table">
          <thead>
            <tr>
              <th>{{ 'app.patrol.discord.cockpit.activity.colCase' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.activity.colTime' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.activity.colChannel' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.activity.colAction' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.activity.colReason' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.activity.colReputation' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of recentCases(); track item.caseId) {
              <tr>
                <td>
                  <button
                    type="button"
                    class="case-link"
                    (click)="openCase(item.caseId)"
                  >
                    <code>{{ item.caseId.slice(0, 8) }}</code>
                  </button>
                </td>
                <td>{{ formatDate(item.occurredAt) }}</td>
                <td>{{ item.channelName }}</td>
                <td>
                  <span class="action-badge" [attr.data-action]="item.action">
                    {{ actionLabel(item.action) | translate }}
                  </span>
                </td>
                <td>{{ item.reason }}</td>
                <td>
                  @if (item.reputationDelta !== undefined) {
                    <span
                      [class.rep-delta--pos]="item.reputationDelta > 0"
                      [class.rep-delta--neg]="item.reputationDelta < 0"
                    >
                      @if (item.reputationDelta > 0) {
                        +{{ item.reputationDelta }}
                      } @else {
                        {{ item.reputationDelta }}
                      }
                    </span>
                  } @else {
                    —
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>
    } @else {
      <p class="empty-hint">
        {{ 'app.patrol.discord.cockpit.activity.noCases' | translate }}
      </p>
    }
  </section>
  }
</div>
